import { render, staticRenderFns } from "./ShipmentsTable.vue?vue&type=template&id=2f47fb1c&scoped=true&"
import script from "./ShipmentsTable.vue?vue&type=script&lang=js&"
export * from "./ShipmentsTable.vue?vue&type=script&lang=js&"
import style0 from "./ShipmentsTable.vue?vue&type=style&index=0&id=2f47fb1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f47fb1c",
  null
  
)

export default component.exports